import React, { useState, useEffect, useRef } from "react";
import {
  UserIcon,
  ClipboardDocumentListIcon,
  DocumentTextIcon,
  // ChevronDoubleLeftIcon,
  // ChevronDoubleRightIcon,
  ClipboardDocumentIcon,
  Bars3Icon,
  XMarkIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";
import { RiLogoutCircleRLine } from "react-icons/ri";
import profile from "../assets/profile.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/LoginContext";
import { USERROLEENUM } from "../helper/constant";
import { getCookieData } from "../helper/api";
import { formatAsSevenDigitNumber } from "../helper/convertionHealper";

interface MenuItem {
  icon: React.ReactNode;
  text: string;
  path?: string;
  submenu?: MenuItem[];
  role?: number[];
  menuType: string;
}

const headerItems: MenuItem[] = [
  {
    icon: <ClipboardDocumentIcon className="h-5 w-5" />,
    text: "My TimeSheet",
    path: "/",
    role: [
      USERROLEENUM.ADMIN,
      USERROLEENUM.EMPLOYEE,
      USERROLEENUM.HR,
      USERROLEENUM.FINANCE,
      USERROLEENUM.MANAGER,
      USERROLEENUM.TSApprover,
    ],
    menuType: "timesheet",
  },
  {
    icon: <DocumentTextIcon className="h-5 w-5" />,
    text: "Reports",
    path: "",
    role: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.FINANCE],
    menuType: "timesheet",
    submenu: [
      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "Missing TS",
        path: "/timesheetReport",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.FINANCE],
        menuType: "timesheet",
      },

      {
        icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
        text: "Project Timesheets Reports",
        path: "/projectTimesheetsReport",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.FINANCE],
        menuType: "timesheet",
      },
      {
        icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
        text: "Timesheets",
        path: "/timesheets",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.FINANCE],
        menuType: "timesheet",
      },
      {
        icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
        text: "Skills Report",
        path: "/skillsreport",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.FINANCE],
        menuType: "timesheet",
      },
      {
        icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
        text: "Export Timesheets",
        path: "/exporttimesheets",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.FINANCE],
        menuType: "timesheet",
      },
      {
        icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
        text: "Utilisation Report",
        path: "/monthlyfinanceReport",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.FINANCE],
        menuType: "timesheet",
      },
      {
        icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
        text: "Leave Reports",
        path: "/leaveReports",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.FINANCE],
        menuType: "timesheet",
      },
      {
        icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
        text: "Discrepancy",
        path: "/discrepancyReports",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.FINANCE],
        menuType: "timesheet",
      },
      {
        icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
        text: "Movement Register",
        path: "/movementregister",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.FINANCE],
        menuType: "timesheet",
      },
      {
        icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
        text: "Employee Assignment Directory",
        path: "/employeeAssignmentDirectory",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.FINANCE],
        menuType: "timesheet",
      },
    ],
  },
  {
    icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
    text: "Manage Project",
    path: "/manageproject",
    role: [USERROLEENUM.MANAGER],
    menuType: "timesheet",
  },
  {
    icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
    text: "Manage",
    path: "",
    role: [USERROLEENUM.HR, USERROLEENUM.ADMIN],
    menuType: "timesheet",
    submenu: [
      {
        icon: <ClipboardDocumentListIcon className="h-5 w-5" />,
        text: "Manage Client and Project",
        path: "/client",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR],
        menuType: "timesheet",
      },
      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "Manage User",
        path: "/admin/user",
        role: [USERROLEENUM.ADMIN],
        menuType: "admin",
      },
      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "Manage Role",
        path: "/admin/role",
        role: [USERROLEENUM.ADMIN],
        menuType: "admin",
      },
      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "Manage Department",
        path: "/admin/department",
        role: [USERROLEENUM.ADMIN],
        menuType: "admin",
      },
    ],
  },
  {
    icon: <DocumentTextIcon className="h-5 w-5" />,
    text: "Approve/Reject Timesheet",
    path: "/approveRejectList",
    role: [
      USERROLEENUM.MANAGER,
      USERROLEENUM.ADMIN,
      USERROLEENUM.HR,
      USERROLEENUM.TSApprover,
      USERROLEENUM.FINANCE,
    ],
    menuType: "timesheet",
  },
  // {
  //   icon: <DocumentTextIcon className="h-5 w-5" />,
  //   text: "IPMS",
  //   path: "",
  //   role: [
  //     USERROLEENUM.ADMIN,
  //     USERROLEENUM.HR,
  //     USERROLEENUM.EMPLOYEE,
  //     USERROLEENUM.TSApprover,
  //     USERROLEENUM.MANAGER,
  //     USERROLEENUM.FINANCE,
  //   ],
  //   menuType: "ipms",
  //   submenu: [
  //     {
  //       icon: <DocumentTextIcon className="h-5 w-5" />,
  //       text: "Dashboard",
  //       path: "/ipms",
  //       role: [
  //         USERROLEENUM.ADMIN,
  //         USERROLEENUM.HR,
  //         USERROLEENUM.EMPLOYEE,
  //         USERROLEENUM.TSApprover,
  //         USERROLEENUM.MANAGER,
  //         USERROLEENUM.FINANCE,
  //       ],
  //       menuType: "ipms",
  //     },

  //     {
  //       icon: <DocumentTextIcon className="h-5 w-5" />,
  //       text: "Employee Goals",
  //       path: "/ipms/employeegoals",
  //       role: [
  //         USERROLEENUM.ADMIN,
  //         USERROLEENUM.HR,
  //         USERROLEENUM.MANAGER,
  //         USERROLEENUM.FINANCE,
  //       ],
  //       menuType: "ipms",
  //     },
  //     {
  //       icon: <DocumentTextIcon className="h-5 w-5" />,
  //       text: "Employee Quarterly Assessment",
  //       path: "/ipms/employeeGoalAssessment",
  //       role: [USERROLEENUM.ADMIN, USERROLEENUM.MANAGER, USERROLEENUM.HR, USERROLEENUM.FINANCE],
  //       menuType: "ipms",
  //     },
  //     // {
  //     //   icon: <DocumentTextIcon className="h-5 w-5" />,
  //     //   text: "Employee Final Assessment",
  //     //   path: "/ipms/employeeFinalGoalAssessment",
  //     //   role: [
  //     //     USERROLEENUM.ADMIN,
  //     //     USERROLEENUM.HR,
  //     //   ],
  //     //   menuType: "ipms",
  //     // },
  //     {
  //       icon: <DocumentTextIcon className="h-5 w-5" />,
  //       text: "Manage Goals",
  //       path: "/ipms/manageGoals",
  //       role: [USERROLEENUM.ADMIN],
  //       menuType: "ipms",
  //     },
  //     {
  //       icon: <DocumentTextIcon className="h-5 w-5" />,
  //       text: "Change Appraiser",
  //       path: "/ipms/employees_list",
  //       role: [USERROLEENUM.ADMIN],
  //       menuType: "ipms",
  //     },
  //     {
  //       icon: <DocumentTextIcon className="h-5 w-5" />,
  //       text: "Reports",
  //       path: "/ipms/ipmsreport",
  //       role: [USERROLEENUM.ADMIN],
  //       menuType: "ipms",
  //     },
  //     {
  //       icon: <DocumentTextIcon className="h-5 w-5" />,
  //       text: "Guidelines / FAQ",
  //       path: "/ipms/guidelines",
  //       role: [
  //         USERROLEENUM.ADMIN,
  //         USERROLEENUM.HR,
  //         USERROLEENUM.EMPLOYEE,
  //         USERROLEENUM.TSApprover,
  //         USERROLEENUM.MANAGER,
  //         USERROLEENUM.FINANCE,
  //       ],
  //       menuType: "ipms",
  //     },
  //     {
  //       icon: <DocumentTextIcon className="h-5 w-5" />,
  //       text: "FlowCharts",
  //       path: "/ipms/flowcharts",
  //       role: [
  //         USERROLEENUM.ADMIN,
  //         USERROLEENUM.HR,
  //         USERROLEENUM.EMPLOYEE,
  //         USERROLEENUM.TSApprover,
  //         USERROLEENUM.MANAGER,
  //         USERROLEENUM.FINANCE,
  //       ],
  //       menuType: "ipms",
  //     },
  //   ],
  // },
  {
    icon: <DocumentTextIcon className="h-5 w-5" />,
    text: "IPMS (New)",
    path: "",
    role: [
      USERROLEENUM.ADMIN,
      USERROLEENUM.HR,
      USERROLEENUM.EMPLOYEE,
      USERROLEENUM.TSApprover,
      USERROLEENUM.MANAGER,
      USERROLEENUM.FINANCE,
    ],
    menuType: "ipms_new",
    submenu: [
      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "Dashboard",
        path: "/ipms_new",
        role: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.EMPLOYEE,
          USERROLEENUM.TSApprover,
          USERROLEENUM.MANAGER,
          USERROLEENUM.FINANCE,
        ],
        menuType: "ipms_new",
      },
      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "Employee Goals",
        path: "/ipms_new/employeegoals",
        role: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.MANAGER,
          USERROLEENUM.FINANCE,
        ],
        menuType: "ipms_new",
      },
      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "Employee Quarterly Assessment",
        path: "/ipms_new/employeeGoalAssessment",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.MANAGER, USERROLEENUM.HR, USERROLEENUM.FINANCE],
        menuType: "ipms_new",
      },
      // {
      //   icon: <DocumentTextIcon className="h-5 w-5" />,
      //   text: "Employee Final Assessment",
      //   path: "/ipms_new/employeeFinalGoalAssessment",
      //   role: [
      //     USERROLEENUM.ADMIN,
      //     USERROLEENUM.HR,
      //   ],
      //   menuType: "ipms_new",
      // },

      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "Manage Goals",
        path: "/ipms_new/manageGoals",
        role: [USERROLEENUM.ADMIN],
        menuType: "ipms_new",
      },
      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "Change Appraiser",
        path: "/ipms_new/employees_list",
        role: [USERROLEENUM.ADMIN],
        menuType: "ipms_new",
      },
      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "Reports",
        path: "/ipms_new/ipmsreport",
        role: [USERROLEENUM.ADMIN, USERROLEENUM.HR],
        menuType: "ipms_new",
      },
      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "Guidelines / FAQ",
        path: "/ipms_new/guidelines",
        role: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.EMPLOYEE,
          USERROLEENUM.TSApprover,
          USERROLEENUM.MANAGER,
          USERROLEENUM.FINANCE,
        ],
        menuType: "ipms_new",
      },
      {
        icon: <DocumentTextIcon className="h-5 w-5" />,
        text: "FlowCharts",
        path: "/ipms_new/flowcharts",
        role: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.EMPLOYEE,
          USERROLEENUM.TSApprover,
          USERROLEENUM.MANAGER,
          USERROLEENUM.FINANCE,
        ],
        menuType: "ipms_new",
      },
    ],
  },
];

const Header: React.FC<{ menuName: string }> = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const userRole = getCookieData("roleId")
    ? Number(getCookieData("roleId"))
    : user
    ? user.role_id
    : null;
  const [expanded] = useState<boolean>(true);
  const [openMenuIndex, setOpenMenuIndex] = useState<number | null>(null);
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState<number | null>(null);
  const [mobileOpenSubmenuIndex, setMobileOpenSubmenuIndex] = useState<number | null>(null);
  const [profileDropdownOpen, setProfileDropdownOpen] =
    useState<boolean>(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);
  const menuRef = useRef<HTMLUListElement>(null);
  const profileRef = useRef<HTMLDivElement>(null);

  const location = useLocation();

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpenMenuIndex(null); // Close the submenu
        // setProfileDropdownOpen(false); // Close the profile dropdown
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = (index: number) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const toggleProfileDropdown = () => {
    setProfileDropdownOpen(!profileDropdownOpen);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="bg-gray-900 w-full text-white py-4 px-4 sm:px-6 lg:px-8 sticky top-0 z-[99] backdrop-blur-md">
      <div className="flex justify-between items-center mx-auto 2xl:container">
        <div className="flex items-center space-x-4">
          {/* <button
            onClick={() => setExpanded((curr) => !curr)}
            className='p-1.5 rounded-lg bg-gray-50 hover:bg-gray-100 text-gray-800 hidden lg:block'
          >
            {expanded ? (
              <ChevronDoubleLeftIcon className='h-5 w-5' />
            ) : (
              <ChevronDoubleRightIcon className='h-5 w-5' />
            )}
          </button> */}
          <button
            onClick={toggleMobileMenu}
            type="button"
            className="inline-flex items-center justify-center p-2 w-10 h-10 text-sm text-gray-500 rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 lg:hidden"
            aria-controls="navbar-hamburger"
            aria-expanded={mobileMenuOpen}
          >
            <span className="sr-only">Open main menu</span>
            {mobileMenuOpen ? (
              <XMarkIcon className="w-5 h-5" />
            ) : (
              <Bars3Icon className="w-5 h-5" />
            )}
          </button>
          <div className="hidden lg:flex items-center space-x-4">
            {headerItems.map(
              (item, index) =>
                userRole &&
                item.role?.includes(userRole) && (
                  <div key={index} className="relative">
                    <button
                      className={`flex items-center text-sm space-x-2 ${
                        item.path &&
                        item.path !== "/" &&
                        location.pathname.startsWith(item.path)
                          ? "border-b border-gray-300 pb-2"
                          : location.pathname === "/" && item.path === "/"
                          ? "border-b border-gray-300 pb-2"
                          : item.submenu?.some((sub) => sub.path && location.pathname.startsWith(sub.path))
                          ? "border-b border-gray-300 pb-2"
                          : openSubMenuIndex === index
                          ? "border-b border-gray-300 pb-2"
                          : ""
                      }`}
                      onClick={() => {
                        if (item.submenu) {
                          setOpenSubMenuIndex(index);
                          toggleMenu(index);
                        } else if (item.path) {
                          setOpenSubMenuIndex(null);
                          navigate(item.path);
                        } else {
                          return null;
                        }
                      }}
                    >
                      {item.icon}
                      {expanded && (
                        <div className="flex">
                          <span className="hidden md:inline w-full">
                            {item.text}{" "}
                          </span>{" "}
                          {item.submenu && (
                            <ChevronDownIcon className="h-5 w-5 text-gray-400" />
                          )}
                        </div>
                      )}
                    </button>
                    {item.submenu && openMenuIndex === index && (
                      <ul
                        ref={menuRef}
                        className="absolute left-0 top-full mt-2 w-48 bg-white text-gray-800 shadow-lg rounded-md"
                        onMouseLeave={() => setOpenMenuIndex(null)}
                      >
                        {item.submenu.map(
                          (subItem, subIndex) =>
                            subItem.role?.includes(userRole) &&
                            subItem.path && (
                              <li
                                key={subIndex}
                                className="flex items-center p-2 hover:bg-gray-100"
                              >
                                {subItem.icon}
                                <Link to={subItem.path} className="ml-2">
                                  {subItem.text}
                                </Link>
                              </li>
                            )
                        )}
                      </ul>
                    )}
                  </div>
                )
            )}
          </div>
        </div>
        <div className="hidden lg:flex items-center space-x-4 pl-3 ">
          {headerItems.filter(
            (item) => userRole && item.role?.includes(userRole)
          ).length > 4 ? (
            <div
              ref={profileRef}
              className={`relative flex items-center border-gray-600 ${
                headerItems.filter(
                  (item) => userRole && item.role?.includes(userRole)
                ).length > 4
                  ? ""
                  : "border-l pl-3"
              }   `}
            >
              <button
                onClick={toggleProfileDropdown}
                className="flex items-center space-x-3"
              >
                <img
                  src={user?.picture ?? profile}
                  alt="profile-icon"
                  className="w-10 h-10 rounded-md"
                />
                <ChevronDownIcon className="h-5 w-5 text-gray-300" />
              </button>
              {profileDropdownOpen && (
                <ul
                  className="absolute right-0 top-full mt-2 w-64 bg-white text-gray-800 shadow-lg rounded-md p-3"
                  onMouseLeave={() => setProfileDropdownOpen(false)}
                >
                  <li className="mb-2">
                    <div className="leading-4">
                      <h4 className="font-semibold capitalize">
                        {user.manager_name}
                      </h4>
                      <span className="text-xs text-gray-400 capitalize">
                        Manager
                      </span>
                    </div>
                  </li>
                  <li className="mb-2">
                    <div className="leading-4">
                      <h4 className="font-semibold capitalize">
                        {user.ldap_uid}
                      </h4>
                      <span className="text-xs text-gray-400 capitalize">
                        {user?.employee_id &&
                          formatAsSevenDigitNumber(user.employee_id)}
                      </span>
                    </div>
                  </li>
                  <li className="border-t pt-2 mt-2">
                    <button
                      onClick={logout}
                      className="flex items-center space-x-2 w-full text-left p-2 hover:bg-gray-100"
                    >
                      <RiLogoutCircleRLine className="h-5 w-5" />
                      <span>Logout</span>
                    </button>
                  </li>
                </ul>
              )}
            </div>
          ) : (
            <>
              {expanded && (
                <div className="leading-4">
                  <h4 className="font-semibold capitalize">
                    {user.manager_name}
                  </h4>
                  <span className="text-xs text-gray-400 capitalize">
                    Manager
                  </span>
                </div>
              )}
              <div className="relative flex items-center space-x-3 border-l border-gray-600 pl-3">
                <img
                  src={user?.picture ?? profile}
                  alt="profile-icon"
                  className="w-10 h-10 rounded-md"
                />
                {expanded && (
                  <div className="leading-4">
                    <h4 className="font-semibold capitalize">
                      {user.ldap_uid}
                    </h4>
                    <span className="text-xs text-gray-400 capitalize">
                      {user?.employee_id &&
                        formatAsSevenDigitNumber(user.employee_id)}
                    </span>
                  </div>
                )}
                <button onClick={logout} className="rounded-lg px-5">
                  <RiLogoutCircleRLine className="h-8 w-8 text-gray-100" />
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      {mobileMenuOpen && (
        <div id="navbar-hamburger" className="lg:hidden">
          <ul className="flex flex-col font-medium mt-4 rounded-lg bg-gray-900 text-white">
            {headerItems.map(
              (item, index) =>
                userRole &&
                item.role?.includes(userRole) && (
                  <li key={index}>
                    <button
                      className="flex items-center space-x-2 w-full text-left p-2 hover:bg-gray-600 dark:hover:bg-gray-700"
                      onClick={() => {
                        if (item.submenu) {
                          setMobileOpenSubmenuIndex(
                            mobileOpenSubmenuIndex === index ? null : index
                          );
                        } else if (item.path) {
                          navigate(item.path);
                          setMobileMenuOpen(false);
                        }
                      }}
                    >
                      {item.icon}
                      <span className="ml-2">{item.text}</span>
                      {item.submenu && (
                        <ChevronDownIcon
                          className={`h-4 w-4 ml-auto transition-transform ${
                            mobileOpenSubmenuIndex === index ? "rotate-180" : ""
                          }`}
                        />
                      )}
                    </button>
                    {item.submenu && mobileOpenSubmenuIndex === index && (
                      <ul className="pl-4">
                        {item.submenu
                          .filter(
                            (subItem) =>
                              subItem.role?.includes(userRole as number) &&
                              !!subItem.path
                          )
                          .map((subItem, subIndex) => (
                            <li
                              key={subIndex}
                              className="flex items-center p-2 hover:bg-gray-600 dark:hover:bg-gray-700 cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(subItem.path as string);
                                setMobileMenuOpen(false);
                                setMobileOpenSubmenuIndex(null);
                              }}
                            >
                              {subItem.icon}
                              <span className="ml-2">{subItem.text}</span>
                            </li>
                          ))}
                      </ul>
                    )}
                  </li>
                )
            )}
            <li className="mt-4 p-4 border-t border-gray-600">
              <div className="flex items-center space-x-3">
                <img
                  src={user?.picture ?? profile}
                  alt="profile-icon"
                  className="w-8 h-8 rounded-md"
                />
                <div className="text-sm">
                  <h4 className="font-semibold">{user.ldap_uid}</h4>
                  <span className="text-xs text-gray-400">
                    {user.employee_id}
                  </span>
                </div>
              </div>
              <div className="leading-4 my-4">
                <h4 className="font-semibold capitalize">
                  {user.manager_name}
                </h4>
                <span className="text-xs text-gray-400 capitalize">
                  Manager
                </span>
              </div>
              <button
                onClick={logout}
                className="mt-4 flex items-center space-x-2 w-full text-left py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-300"
              >
                <UserIcon className="h-5 w-5" />
                <span>Logout</span>
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
